<template>
<div class="champion-wrap">
    <h2 class="champion-label">エンデューロ全日本チャンピオン</h2>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('100')"><span class="history__head--circle">2005-2010</span></button>
        <div class="champions">
            <section class="champions__sec">
                <h2 class="year-title">2005年<span class="year-title__sub">平成17年</span></h2>
                <ul>
                    <li>鈴木健二／インターナショナル</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2006年<span class="year-title__sub">平成18年</span></h2>
                <ul>
                    <li>藤原広喜／インターナショナル</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2007年<span class="year-title__sub">平成19年</span></h2>
                <ul>
                    <li>鈴木健二／インターナショナル</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2008年<span class="year-title__sub">平成20年</span></h2>
                <ul>
                    <li>石井正美／インターナショナル</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2009年<span class="year-title__sub">平成21年</span></h2>
                <ul>
                    <li>池田智泰／インターナショナル</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2010年<span class="year-title__sub">平成22年</span></h2>
                <ul>
                    <li>小池田猛／インターナショナルA</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('110')"><span class="history__head--circle">2011-2020</span></button>
        <div class="champions">
            <section class="champions__sec">
                <h2 class="year-title">2011年<span class="year-title__sub">平成23年</span></h2>
                <ul>
                    <li>内山裕太郎／インターナショナルA</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2012年<span class="year-title__sub">平成24年</span></h2>
                <ul>
                    <li>鈴木健二／インターナショナルA</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2013年<span class="year-title__sub">平成25年</span></h2>
                <ul>
                    <li>内山裕太郎／インターナショナルA</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2014年<span class="year-title__sub">平成26年</span></h2>
                <ul>
                    <li>鈴木健二／インターナショナルA</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2015年<span class="year-title__sub">平成27年</span></h2>
                <ul>
                    <li>釘村 忠／インターナショナルA</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2016年<span class="year-title__sub">平成28年</span></h2>
                <ul>
                    <li>鈴木健二／インターナショナルA</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2017年<span class="year-title__sub">平成29年</span></h2>
                <ul>
                    <li>釘村 忠／インターナショナルA</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2018年<span class="year-title__sub">平成30年</span></h2>
                <ul>
                    <li>前橋孝洋／インターナショナルA</li>
                    <li>保坂修一／インターナショナルB</li>
                    <li>近藤香織／ウィメンズ</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2019年<span class="year-title__sub">平成31年/令和元年</span></h2>
                <ul>
                    <li>釘村 忠／インターナショナルA</li>
                    <li>神馬 匠／インターナショナルB</li>
                    <li>菅原聖子／ウィメンズ</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2020年<span class="year-title__sub">令和2年</span></h2>
                <ul>
                    <li>釘村 忠／インターナショナルA</li>
                    <li>渡邉 誉／インターナショナルB</li>
                    <li>松本亜希子／ウィメンズ</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2021年<span class="year-title__sub">令和3年</span></h2>
                <ul>
                    <li>飯塚 翼／インターナショナルA</li>
                    <li>酢崎 友哉／インターナショナルB</li>
                    <li>保坂 明日那／ウィメンズ</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2022年<span class="year-title__sub">令和4年</span></h2>
                <ul>
                    <li>馬場 亮太／インターナショナルA</li>
                    <li>向坊 拓巳／インターナショナルB</li>
                    <li>太田 晴美／ウィメンズ</li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
    import Mixin from '@/mixins/mixin.js'
    export default {
        data: function() {
            return {
                show_contents: ['100']
            }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">

</style>